<template>
  <div class="unidades-table">
    <!-- Toolbar: búsqueda + filtro -->
    <div class="unidades-table__toolbar">
      <div class="unidades-table__search-wrapper">
        <input
          v-model="filtroNombre"
          type="text"
          placeholder="Buscar por nombre de producto…"
          class="unidades-table__search"
        />
      </div>

      <button
        type="button"
        class="unidades-table__filter-btn"
        @click="mostrarFiltroCategorias = true"
      >
        Filtrar por categoría
      </button>
    </div>

    <!-- Lista -->
    <div
      v-if="productosFiltrados.length === 0"
      class="unidades-table__empty"
    >
      No se encontraron productos con unidades para ese filtro.
    </div>

    <div
      v-else
      class="unidades-table__list"
    >
      <div
        v-for="producto in productosFiltrados"
        :key="producto.id_producto"
        class="unidades-row"
      >
        <div class="unidades-row__left">
          <p class="unidades-row__name">
            {{ producto.nombre_producto }}
          </p>
          <p class="unidades-row__category">
            {{ producto.categoria_nombre || 'Sin categoría' }}
          </p>
        </div>

        <button
          type="button"
          class="unidades-row__btn"
          @click="verUnidades(producto)"
        >
          Ver unidades
        </button>
      </div>
    </div>

    <!-- Modal detalle unidades por producto -->
    <ModalUnidadesPorProducto
      v-if="mostrarModalUnidades"
      :producto="productoSeleccionado"
      @cerrar="mostrarModalUnidades = false"
    />

    <!-- Modal filtro categorías -->
    <ModalFiltroCategorias
      v-if="mostrarFiltroCategorias"
      :categorias="categoriasDisponibles"
      :seleccionadas="categoriasSeleccionadas"
      @cerrar="mostrarFiltroCategorias = false"
      @aplicar="aplicarFiltroCategorias"
    />
  </div>
</template>
<script>
import ModalUnidadesPorProducto from './ModalUnidadesPorProducto.vue';
import ModalFiltroCategorias from './ModalFiltroCategorias.vue';

export default {
  name: 'TablaUnidades',
  components: {
    ModalUnidadesPorProducto,
    ModalFiltroCategorias,
  },
  props: {
    // viene desde DashboardUnidades (resUni.data)
    unidades: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      filtroNombre: '',
      categoriasSeleccionadas: [],
      mostrarFiltroCategorias: false,
      mostrarModalUnidades: false,
      productoSeleccionado: null,
    };
  },
  computed: {
    // Categorías únicas disponibles (strings)
    categoriasDisponibles() {
      const set = new Set(
        (this.unidades || [])
          .map((u) => u.categoria_nombre)
          .filter(Boolean)
      );
      return Array.from(set);
    },

    // Un solo registro por producto (como en tu código original)
    productosUnicos() {
      const map = {};
      const base = this.unidades || [];

      return base.filter((item) => {
        if (!item.id_producto) return false;
        if (!map[item.id_producto]) {
          map[item.id_producto] = true;
          return true;
        }
        return false;
      });
    },

    // Filtro por nombre + categoría
    productosFiltrados() {
      const nombreFiltro = this.filtroNombre.trim().toLowerCase();

      return this.productosUnicos.filter((p) => {
        const nombre = (p.nombre_producto || '').toLowerCase();
        const cat = p.categoria_nombre || '';

        const coincideNombre =
          !nombreFiltro || nombre.includes(nombreFiltro);

        const coincideCategoria =
          this.categoriasSeleccionadas.length === 0 ||
          this.categoriasSeleccionadas.includes(cat);

        return coincideNombre && coincideCategoria;
      });
    },
  },
  methods: {
    verUnidades(producto) {
      if (!producto) {
        console.error('Producto no válido al intentar ver unidades.');
        this.$toast?.error(
          'No se pudo mostrar el detalle de unidades para este producto.'
        );
        return;
      }

      this.productoSeleccionado = producto;
      this.mostrarModalUnidades = true;
    },

    aplicarFiltroCategorias(seleccionadas) {
      try {
        if (!Array.isArray(seleccionadas)) {
          throw new Error('Selección de categorías inválida.');
        }

        this.categoriasSeleccionadas = [...seleccionadas];

        // Toast de éxito según haya o no filtros activos
        if (this.categoriasSeleccionadas.length > 0) {
          this.$toast?.success('Filtro de categorías aplicado.');
        } else {
          this.$toast?.success('Filtros de categorías limpiados.');
        }
      } catch (error) {
        console.error('Error al aplicar filtro de categorías:', error);
        this.$toast?.error('No se pudo aplicar el filtro de categorías.');
      }
    },
  },
};
</script>


<style scoped>
.unidades-table {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

/* Toolbar */
.unidades-table__toolbar {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0.2rem;
}

.unidades-table__search-wrapper {
  flex: 1;
  min-width: 180px;
}

.unidades-table__search {
  width: 100%;
  border-radius: 999px;
  border: 1px solid rgba(148, 163, 184, 0.8);
  background: radial-gradient(
      circle at 0 0,
      rgba(148, 163, 184, 0.24),
      rgba(15, 23, 42, 0.98)
    );
  color: #e5e7eb;
  font-size: 0.8rem;
  padding: 0.45rem 0.9rem;
  outline: none;
}

.unidades-table__search::placeholder {
  color: rgba(148, 163, 184, 0.85);
}

.unidades-table__filter-btn {
  border-radius: 999px;
  border: 1px solid rgba(148, 163, 184, 0.7);
  background: rgba(15, 23, 42, 0.9);
  color: #e5e7eb;
  font-size: 0.78rem;
  padding: 0.35rem 0.8rem;
  cursor: pointer;
  white-space: nowrap;
  transition:
    background 0.16s ease,
    border-color 0.16s ease,
    box-shadow 0.18s ease,
    transform 0.08s ease;
}

.unidades-table__filter-btn:hover {
  background: rgba(15, 23, 42, 1);
  border-color: rgba(148, 163, 184, 0.95);
  box-shadow: 0 10px 26px rgba(15, 23, 42, 0.9);
}

/* Lista */
.unidades-table__list {
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
}

.unidades-table__empty {
  font-size: 0.8rem;
  color: #cbd5f5;
  padding: 0.4rem 0.3rem;
}

/* Fila tipo card */
.unidades-row {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.55rem 0.75rem;
  border-radius: 1rem;
  background: rgba(15, 23, 42, 0.86);
  border: 1px solid rgba(148, 163, 184, 0.4);
  box-shadow: 0 10px 32px rgba(15, 23, 42, 0.7);
}

.unidades-row__left {
  flex: 1;
  min-width: 0;
}

.unidades-row__name {
  font-size: 0.9rem;
  color: #e5e7eb;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.unidades-row__category {
  font-size: 0.78rem;
  color: #9ca3af;
  margin-top: 0.1rem;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

/* Botón "Ver unidades" */
.unidades-row__btn {
  border-radius: 999px;
  border: 1px solid rgba(129, 140, 248, 0.9);
  background: radial-gradient(
      circle at 0 0,
      rgba(129, 140, 248, 0.3),
      rgba(30, 64, 175, 0.95)
    );
  color: #e5e7eb;
  font-size: 0.78rem;
  padding: 0.3rem 0.8rem;
  cursor: pointer;
  white-space: nowrap;
  transition:
    background 0.16s ease,
    box-shadow 0.18s ease,
    transform 0.08s ease;
}

.unidades-row__btn:hover {
  box-shadow: 0 12px 26px rgba(15, 23, 42, 0.95);
}

.unidades-row__btn:active {
  transform: translateY(0);
  box-shadow: 0 7px 18px rgba(15, 23, 42, 1);
}

/* Responsive */
@media (max-width: 640px) {
  .unidades-table__toolbar {
    flex-direction: column;
    align-items: stretch;
  }
  .unidades-table__filter-btn {
    align-self: flex-end;
  }
}
</style>
